import { render, staticRenderFns } from "./group-type.vue?vue&type=template&id=fee9b6a2&scoped=true&"
import script from "./group-type.vue?vue&type=script&lang=js&"
export * from "./group-type.vue?vue&type=script&lang=js&"
import style0 from "./group-type.vue?vue&type=style&index=0&id=fee9b6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee9b6a2",
  null
  
)

export default component.exports